module.exports = __webpack_public_path__ + "2869eb7407bd114527a95c3a2fcdc9f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Partof_FG_Logo_RGB_Line_WOB.png
// module id = 2039
// module chunks = 1